export const FILE = 'FILE';
export const URL = 'URL';

export const TYPE_OF_SOURCE = {
  FILE,
  URL,
};

export default TYPE_OF_SOURCE;



// WEBPACK FOOTER //
// ./src/global/components/FileUploader/constants.js